var debug = false;

function getValue(obj, path) {
  var a = path.split(".")
  var context = obj
  var myregexp = /([a-zA-Z]+)(\[(\d)\])+/ // matches:  item[0]
  var match = null
  for (var i = 0; i < a.length - 1; i += 1) {
    match = myregexp.exec(a[i])
    if (match !== null) {
      context = context[match[1]][match[3]]
    } else {
      context = context[a[i]]
    }
  }
  match = myregexp.exec([a[a.length - 1]])

  if (match !== null) {
    return context[match[1]][match[3]]
  } else {
    return context[a[a.length - 1]]
  }
}

// eslint-disable-next-line no-unused-vars
function updateCartBubble(item_count = null) {
  if (!document.querySelectorAll(".cart-count-bubble span")) {
    return false
  }
  if (item_count === null) {
    fetch(window.Shopify.routes.root + "cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.json()
      })
      .then((cart) => {
        item_count = parseInt(cart.item_count)
      })
  }
  document.querySelectorAll(".cart-count-bubble span").forEach(function (el, i) {
    if (i === 0) {
      el.innerHTML = item_count
    } else if (i === 1) {
      var display = item_count + " item"
      if (item_count !== 1) {
        display += "s"
      }
      el.innerHTML = display
    }
  })
  if (item_count > 0) {
    document
      .getElementById("cart-icon-bubble")
      .querySelector(".cart-count-bubble")
      .classList.remove("hidden")
  } else {
    document
      .getElementById("cart-icon-bubble")
      .querySelector(".cart-count-bubble")
      .classList.add("hidden")
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  )
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button")
  summary.setAttribute("aria-expanded", summary.parentNode.hasAttribute("open"))

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id)
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    )
  })

  if (summary.closest("header-drawer, menu-drawer")) return
  summary.parentElement.addEventListener("keyup", onKeyUpEscape)
})

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container)
  var first = elements[0]
  var last = elements[elements.length - 1]

  removeTrapFocus()

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return

    document.addEventListener("keydown", trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener("focusout", trapFocusHandlers.focusout)
  document.addEventListener("focusin", trapFocusHandlers.focusin)

  if (elementToFocus) {
    elementToFocus.focus()

    if (
      elementToFocus.tagName === "INPUT" &&
      ["search", "text", "email", "url"].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length)
    }
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible")
} catch (e) {
  focusVisiblePolyfill()
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ]
  let currentFocusedElement = null
  let mouseClick = null

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false
    }
  })

  window.addEventListener("mousedown", () => {
    mouseClick = true
  })

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove("focused")

      if (mouseClick) return

      currentFocusedElement = document.activeElement
      currentFocusedElement.classList.add("focused")
    },
    true
  )
}

// eslint-disable-next-line no-unused-vars
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    )
  })
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*")
  })
  document.querySelectorAll("video").forEach((video) => video.pause())
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause()
  })
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin)
  document.removeEventListener("focusout", trapFocusHandlers.focusout)
  document.removeEventListener("keydown", trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return

  const openDetailsElement = event.target.closest("details[open]")
  if (!openDetailsElement) return

  const summaryElement = openDetailsElement.querySelector("summary")
  openDetailsElement.removeAttribute("open")
  summaryElement.setAttribute("aria-expanded", false)
  summaryElement.focus()
}

class QuantityInput extends HTMLElement {
  constructor() {
    super()
    this.input = this.querySelector("input")
    this.changeEvent = new Event("change", { bubbles: true })
    this.input.addEventListener("change", this.onInputChange.bind(this))
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    )
  }

  quantityUpdateUnsubscriber = undefined

  connectedCallback() {
    this.validateQtyRules()
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    )
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber()
    }
  }

  onInputChange() {
    this.validateQtyRules()
  }

  onButtonClick(event) {
    event.preventDefault()
    const previousValue = this.input.value

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent)
  }

  validateQtyRules() {
    const value = parseInt(this.input.value)
    if (this.input.min) {
      const min = parseInt(this.input.min)
      const buttonMinus = this.querySelector(".quantity__button[name='minus']")
      buttonMinus.classList.toggle("disabled", value <= min)
    }
    if (this.input.max) {
      const max = parseInt(this.input.max)
      const buttonPlus = this.querySelector(".quantity__button[name='plus']")
      buttonPlus.classList.toggle("disabled", value >= max)
    }
  }
}

customElements.define("quantity-input", QuantityInput)

// eslint-disable-next-line no-unused-vars
function debounce(fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

// eslint-disable-next-line no-unused-vars
function throttle(fn, delay) {
  let lastCall = 0
  return function (...args) {
    const now = new Date().getTime()
    if (now - lastCall < delay) {
      return
    }
    lastCall = now
    return fn(...args)
  }
}

// eslint-disable-next-line no-unused-vars
function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${type}` },
  }
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments)
  }
}

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i]
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i
      return i
    }
  }
}

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback)
}

Shopify.postLink = function (path, options) {
  options = options || {}
  var method = options["method"] || "post"
  var params = options["parameters"] || {}

  var form = document.createElement("form")
  form.setAttribute("method", method)
  form.setAttribute("action", path)

  for (var key in params) {
    var hiddenField = document.createElement("input")
    hiddenField.setAttribute("type", "hidden")
    hiddenField.setAttribute("name", key)
    hiddenField.setAttribute("value", params[key])
    form.appendChild(hiddenField)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid)
  this.provinceEl = document.getElementById(province_domid)
  this.provinceContainer = document.getElementById(options["hideElement"] || province_domid)

  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this))

  this.initCountry()
  this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default")
    Shopify.setSelectorByValue(this.countryEl, value)
    this.countryHandler()
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default")
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value)
    }
  },

  countryHandler: function () {
    var opt = this.countryEl.options[this.countryEl.selectedIndex]
    var raw = opt.getAttribute("data-provinces")
    var provinces = JSON.parse(raw)

    this.clearOptions(this.provinceEl)
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none"
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option")
        opt.value = provinces[i][0]
        opt.innerHTML = provinces[i][1]
        this.provinceEl.appendChild(opt)
      }

      this.provinceContainer.style.display = ""
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild)
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option")
      opt.value = values[i]
      opt.innerHTML = values[i]
      selector.appendChild(opt)
    }
  },
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super()

    this.mainDetailsToggle = this.querySelector("details")

    this.addEventListener("keyup", this.onKeyUp.bind(this))
    this.addEventListener("focusout", this.onFocusOut.bind(this))
    this.bindEvents()
    this.querySelectorAll(".js-close").forEach((item) => {
      item.addEventListener("click", (event) => {
        this.mainDetailsToggle
          .querySelector('summary[aria-controls="menu-drawer"]')
          .setAttribute("aria-expanded", false)
        this.closeMenuDrawer(event)
        document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`)
      })
    })

    const url = new URL(window.location.href)
    const params = new URLSearchParams(url)
    const paraObject = {}
    let utmPassed = false
    url.searchParams.forEach(function (val, key) {
      if (key.startsWith("utm_")) {
        paraObject[key] = val
        utmPassed = true
      }
    })
    let utmSource = ""
    if (paraObject["utm_source"]) {
      utmSource = paraObject["utm_source"].toLowerCase()
    }
    if (utmPassed === false || (utmPassed === true && utmSource === "friendbuy")) {
      document.querySelectorAll(".link-to-refer").forEach(function (el) {
        el.style.display = "block"
      })
    }
    if (utmSource === "friendbuy") {
      document.querySelector(".utility-bar").style.display = "none"
      document.getElementById("menu-drawer").style.top = "0"
      document.querySelector(".section-header").style.paddingTop = "0"
      document.body.style.paddingTop = "0"
    }
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    )
    this.querySelectorAll(
      "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)"
    ).forEach((button) => button.addEventListener("click", this.onCloseButtonClick.bind(this)))
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return

    const openDetailsElement = event.target.closest("details[open]")
    if (!openDetailsElement) return

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement)
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget
    const detailsElement = summaryElement.parentNode
    const parentMenuElement = detailsElement.closest(".has-submenu")
    const isOpen = detailsElement.hasAttribute("open")
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)")

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector("button"))
      summaryElement.nextElementSibling.removeEventListener("transitionend", addTrapFocus)
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault()
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement)

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`)
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening")
        summaryElement.setAttribute("aria-expanded", true)
        parentMenuElement && parentMenuElement.classList.add("submenu-open")
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener("transitionend", addTrapFocus)
      }, 100)
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening")
    })
    summaryElement.setAttribute("aria-expanded", true)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return

    this.mainDetailsToggle.classList.remove("menu-opening")
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open")
      details.classList.remove("menu-opening")
    })
    this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((submenu) => {
      submenu.classList.remove("submenu-open")
    })
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`)
    removeTrapFocus(elementToFocus)
    this.closeAnimation(this.mainDetailsToggle)

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute("aria-expanded", false)
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer()
    })
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details")
    this.closeSubmenu(detailsElement)
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open")
    parentMenuElement && parentMenuElement.classList.remove("submenu-open")
    detailsElement.classList.remove("menu-opening")
    detailsElement.querySelector("summary").setAttribute("aria-expanded", false)
    removeTrapFocus(detailsElement.querySelector("summary"))
    this.closeAnimation(detailsElement)
  }

  closeAnimation(detailsElement) {
    let animationStart

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time
      }

      const elapsedTime = time - animationStart

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation)
      } else {
        detailsElement.removeAttribute("open")
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          )
        }
      }
    }

    window.requestAnimationFrame(handleAnimation)
  }
}

customElements.define("menu-drawer", MenuDrawer)

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super()
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header")
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom")
        ? 1
        : 0
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    )
    this.header.classList.add("menu-open")

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening")
    })

    summaryElement.setAttribute("aria-expanded", true)
    window.addEventListener("resize", this.onResize)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return
    this.header = this.header || document.querySelector(".section-header")
    super.closeMenuDrawer(event, elementToFocus)
    this.header.classList.remove("menu-open")
    window.removeEventListener("resize", this.onResize)
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      )
    document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`)
  }
}

customElements.define("header-drawer", HeaderDrawer)

class ModalDialog extends HTMLElement {
  constructor() {
    super()
    this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, false))
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide()
    })
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (event.pointerType === "mouse" && !event.target.closest("deferred-media, product-model"))
          this.hide()
      })
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide()
      })
    }
  }

  connectedCallback() {
    if (this.moved) return
    this.moved = true
    document.body.appendChild(this)
  }

  show(opener) {
    this.openedBy = opener
    const popup = this.querySelector(".template-popup")
    document.body.classList.add("overflow-hidden")
    this.setAttribute("open", "")
    if (popup) popup.loadContent()
    trapFocus(this, this.querySelector('[role="dialog"]'))
    window.pauseAllMedia()
  }

  hide() {
    document.body.classList.remove("overflow-hidden")
    document.body.dispatchEvent(new CustomEvent("modalClosed"))
    this.removeAttribute("open")
    removeTrapFocus(this.openedBy)
    window.pauseAllMedia()
  }
}
customElements.define("modal-dialog", ModalDialog)

class ModalOpener extends HTMLElement {
  constructor() {
    super()

    const button = this.querySelector("button")

    if (!button) return
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"))
      if (modal) modal.show(button)
    })
  }
}
customElements.define("modal-opener", ModalOpener)

class DeferredMedia extends HTMLElement {
  constructor() {
    super()
    const poster = this.querySelector('[id^="Deferred-Poster-"]')
    if (!poster) return
    poster.addEventListener("click", this.loadContent.bind(this))
  }

  loadContent(focus = true) {
    window.pauseAllMedia()
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div")
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true))

      this.setAttribute("loaded", true)
      const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"))
      if (focus) deferredElement.focus()
      if (deferredElement.nodeName == "VIDEO" && deferredElement.getAttribute("autoplay")) {
        // force autoplay for safari
        deferredElement.play()
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia)

class SliderComponent extends HTMLElement {
  constructor() {
    super()
    this.slider = this.querySelector('[id^="Slider-"]')
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]')
    this.enableSliderLooping = false
    this.currentPageElement = this.querySelector(".slider-counter--current")
    this.pageTotalElement = this.querySelector(".slider-counter--total")
    this.prevButton = this.querySelector('button[name="previous"]')
    this.nextButton = this.querySelector('button[name="next"]')

    if (!this.slider || !this.nextButton) return

    this.initPages()
    const resizeObserver = new ResizeObserver(() => this.initPages())
    resizeObserver.observe(this.slider)

    this.slider.addEventListener("scroll", this.update.bind(this))
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this))
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this))
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    )
    if (this.sliderItemsToShow.length < 2) return
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    )
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1
    this.update()
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]')
    this.initPages()
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return

    const previousPage = this.currentPage
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage
      this.pageTotalElement.textContent = this.totalPages
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      )
    }

    if (this.enableSliderLooping) return

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute("disabled", "disabled")
    } else {
      this.prevButton.removeAttribute("disabled")
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute("disabled", "disabled")
    } else {
      this.nextButton.removeAttribute("disabled")
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    )
  }

  onButtonClick(event) {
    event.preventDefault()
    const step = event.currentTarget.dataset.step || 1
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset
    this.setSlidePosition(this.slideScrollPosition)
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    })
  }
}

customElements.define("slider-component", SliderComponent)

class SlideshowComponent extends SliderComponent {
  constructor() {
    super()
    this.sliderControlWrapper = this.querySelector(".slider-buttons")
    this.enableSliderLooping = true

    if (!this.sliderControlWrapper) return

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide")
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider")
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    )
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    )
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this))
    this.setSlideVisibility()

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false

      this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)")
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true") this.setAutoPlay()
      })
      ;[this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true
          },
          { once: true }
        )
      })
    }

    if (this.slider.getAttribute("data-autoplay") === "true") this.setAutoPlay()
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000
    this.addEventListener("mouseover", this.focusInHandling.bind(this))
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this))
    this.addEventListener("focusin", this.focusInHandling.bind(this))
    this.addEventListener("focusout", this.focusOutHandling.bind(this))

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay")
      this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this))
      this.autoplayButtonIsSetToPlay = true
      this.play()
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play()
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event)
    this.wasClicked = true

    const isFirstSlide = this.currentPage === 1
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name)
      return
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0
    }

    this.setSlidePosition(this.slideScrollPosition)

    this.applyAnimationToAnnouncementBar(event.currentTarget.name)
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout)
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      })
    }, this.announcerBarAnimationDelay)
  }

  update() {
    super.update()
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link")
    this.prevButton.removeAttribute("disabled")

    if (!this.sliderControlButtons.length) return

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active")
      link.removeAttribute("aria-current")
    })
    this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active")
    this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", true)
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay)
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play()
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target)
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return
      this.play()
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play()
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target)
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play()
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause()
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause()
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off")
    clearInterval(this.autoplay)
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed)
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite")
    clearInterval(this.autoplay)
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused")
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      )
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused")
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      )
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset

    this.setSlidePosition(slideScrollPosition)
    this.applyAnimationToAnnouncementBar()
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a")
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex")
          })
        item.setAttribute("aria-hidden", "false")
        item.removeAttribute("tabindex")
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1")
          })
        item.setAttribute("aria-hidden", "true")
        item.setAttribute("tabindex", "-1")
      }
    })
    this.wasClicked = false
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return

    const itemsCount = this.sliderItems.length
    const increment = button === "next" ? 1 : -1

    const currentIndex = this.currentPage - 1
    let nextIndex = (currentIndex + increment) % itemsCount
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex

    const nextSlide = this.sliderItems[nextIndex]
    const currentSlide = this.sliderItems[currentIndex]

    const animationClassIn = "announcement-bar-slider--fade-in"
    const animationClassOut = "announcement-bar-slider--fade-out"

    const isFirstSlide = currentIndex === 0
    const isLastSlide = currentIndex === itemsCount - 1

    const shouldMoveNext =
      (button === "next" && !isLastSlide) || (button === "previous" && isFirstSlide)
    const direction = shouldMoveNext ? "next" : "previous"

    currentSlide.classList.add(`${animationClassOut}-${direction}`)
    nextSlide.classList.add(`${animationClassIn}-${direction}`)

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`)
      nextSlide.classList.remove(`${animationClassIn}-${direction}`)
    }, this.announcerBarAnimationDelay * 2)
  }

  linkToSlide(event) {
    event.preventDefault()
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage)
    this.slider.scrollTo({
      left: slideScrollPosition,
    })
  }
}

customElements.define("slideshow-component", SlideshowComponent)

class VariantSelects extends HTMLElement {
  constructor() {
    super()
    this.j4Discount = {
      skus: Shopify.discount.skuList,
      sub_percent_off: Shopify.discount.subPercentOff,
      otp_percent_off: Shopify.discount.otpPercentOff,
    }

    this.addEventListener("change", function (event) {
      if (debug) {
        console.log("======== CHANGE EVENT =========")
      }
      if (event.target.matches(".selector.dropdown select")) {
        let selectorNumber = parseInt(event.target.parentNode.parentNode.dataset.optionIndex)
        if (debug) {
          console.log("selectorNumber", selectorNumber)
        }
        let currentVal = event.target.value
        currentVariant[selectorNumber] = currentVal
        if (debug) {
          console.log("currentVal", currentVal)
        }
        var path = "values."
        for (var i = 0; i < radioOptions.length; i++) {
          if (selectorNumber === i) {
            path += currentVal + ".values"
          } else if (selectorNumber >= i) {
            path += currentVariant[i] + ".values."
          }
        }
        if (debug) {
          console.log("currentVal", currentVal)
        }
        if (path !== "values.") {
          var currentConfig = getValue(availableOptions, path)
          if (debug) {
            console.log("currentConfig", currentConfig)
          }
          this.updateSingleSelector(selectorNumber, currentConfig, event)
        }
      } else if (event.target.matches(".selector.radio input[type=radio]")) {
        if (debug) {
          console.log("======== CHANGE RADIO =========")
        }
        var optionIndex = jQuery(this).closest(".selector").attr("data-option-index")
        var optionValue = jQuery(this).val()

        jQuery(this)
          .closest("form")
          .find(".single-option-selector")
          .eq(optionIndex)
          .val(optionValue)
          .trigger("change")

        this.updateOtherSelectors(jQuery(this))
      } else if (event.target.matches("input[type=radio]")) {
        if (debug) {
          console.log("======== CHANGE RADIO =========")
        }

        this.updateOptions()
        this.updateMasterId()
        document.getElementById("product-select").value = this.currentVariant?.id
        this.onVariantChange(event)
      }
    })

    this.addEventListener("variant:changed", function (event) {
      this.currentVariant = this.getVariantData().find((e) => e.id === event.detail.id)

      this.renderDescription()
      this.renderImages()
      this.renderImageTag()
      this.renderTopLeft()
      this.renderTopRight()
      this.renderTestimonial()
      this.hideAccordions()
      //this.servings();
      this.renderNutrition()

      this.updateMedia()
      this.updateVariantInput()
      this.renderProductInfo()
      this.updateShareUrl()
      this.updateKidsDropdown()
    })

    /* DOM READY START */
    var firstOption = "",
      secondOption = "",
      thirdOption = "",
      _this = this
    document.addEventListener("DOMContentLoaded", function () {
      // listen for tabbing
      document.body.addEventListener("keyup", function (e) {
        if (e.keyCode == 9) {
          document.body.classList.add("keying")
        }
      })
      document.body.addEventListener("mousedown", function () {
        document.body.classList.remove("keying")
      })

      // initialize selectors
      if (availableOptions.hasOwnProperty("values")) {
        Object.keys(availableOptions.values).forEach(function (optAttribute) {
          if (availableOptions.values[optAttribute].hasOwnProperty("swatch")) {
            var optNumber = availableOptions.values[optAttribute].swatch
            if (optNumber === 0 && (currentVariant[0] === optAttribute || firstOption === "")) {
              firstOption = optAttribute
              const selectEl = document.getElementById(selectorName + optNumber)

              if (selectEl?.tagName === "SELECT") {
                selectEl
                  ?.querySelector('option[value="' + optAttribute + '"]')
                  ?.setAttribute("selected", "")

                selectEl.value = optAttribute
              }

              if (selectEl?.tagName === "FIELDSET") {
                selectEl.querySelectorAll("input").forEach((input) => {
                  input.checked = input.value === optAttribute
                })

                if (selectEl?.querySelector("[data-selected-swatch-value]"))
                  selectEl.querySelector("[data-selected-swatch-value]").innerHTML = optAttribute
              }

              if (debug) {
                console.log("selected selector-0:", optAttribute)
              }
            }
          }
          if (availableOptions.values[optAttribute].hasOwnProperty("values")) {
            Object.keys(availableOptions.values[optAttribute].values).forEach(
              function (optAttribute2) {
                if (
                  availableOptions.values[optAttribute].values[optAttribute2].hasOwnProperty(
                    "swatch"
                  )
                ) {
                  var optNumber = availableOptions.values[optAttribute].values[optAttribute2].swatch
                  if (
                    optNumber === 1 &&
                    (currentVariant[1] === optAttribute2 || secondOption === "")
                  ) {
                    secondOption = optAttribute2
                    const selectEl = document.getElementById(selectorName + optNumber)
                    selectEl
                      ?.querySelector('option[value="' + optAttribute2 + '"]')
                      ?.setAttribute("selected", "")

                    if (selectEl) selectEl.value = optAttribute2
                    if (debug) {
                      console.log("selected selector-1:", optAttribute2)
                    }
                    if (
                      availableOptions.values[optAttribute].values[optAttribute2].hasOwnProperty(
                        "values"
                      )
                    ) {
                      Object.keys(
                        availableOptions.values[optAttribute].values[optAttribute2].values
                      ).forEach(function (optAttribute3) {
                        if (
                          availableOptions.values[optAttribute].values[optAttribute2].values[
                            optAttribute3
                          ].hasOwnProperty("swatch")
                        ) {
                          var optNumber =
                            availableOptions.values[optAttribute].values[optAttribute2].values[
                              optAttribute3
                            ].swatch
                          if (
                            optNumber === 2 &&
                            (currentVariant[2] === optAttribute3 || thirdOption === "")
                          ) {
                            thirdOption = optAttribute3
                            const selectEl = document.getElementById(selectorName + optNumber)
                            selectEl
                              ?.querySelector('option[value="' + optAttribute3 + '"]')
                              ?.setAttribute("selected", "")

                            if (selectEl) selectEl.value = optAttribute3
                            if (debug) {
                              console.log("selected selector-2:", optAttribute3)
                            }
                          }
                        }
                      })
                    }
                  }
                }
              }
            )
          }
        })
      }
      if (thirdOption !== "") {
        _this.updateOtherSelectors($("#" + selectorName + "1"))
      } else if (secondOption !== "") {
        _this.updateOtherSelectors($("#" + selectorName + "0"))
      }

      _this.onVariantChange(new Event("change"))
    })
  }

  connectedCallback() {
    this.addEventListener("swatch:change", () => {
      this.onVariantChange(new Event("change"))
    })
  }
  disconnectedCallback() {
    this.removeEventListener("swatch:change", () => {
      this.onVariantChange(new Event("change"))
    })
  }

  onVariantChange(event) {
    if (debug) {
      console.log("==== VARIANT CHANGE ====")
    }
    this.updateOptions()
    this.updateMasterId()
    if (debug) {
      console.log("master variant", this.currentVariant)
    }
    if (event.target) {
      console.log("event has target")
      this.updateSelectedSwatchValue(event)
      this.updateDropdownSwatch()
    }
    this.toggleAddButton(true, "", false)
    this.updatePickupAvailability()
    this.removeErrorMessage()
    this.updateVariantStatuses()

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true)
      this.setUnavailable()
    } else {
      this.renderDescription()
      this.renderImages()
      this.renderImageTag()
      this.renderTopLeft()
      this.renderTopRight()
      this.renderTestimonial()
      this.hideAccordions()
      //this.servings();
      this.renderNutrition()

      this.updateMedia()
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
      this.updateShareUrl()
      this.updateKidsSubscriptionWidget()
    }
  }

  updateDropdownSwatch() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return

    const dropdownSwatches = document.querySelectorAll(".dropdown-swatch .swatch")
    dropdownSwatches.forEach((swatch) => {
      if (this.currentVariant.featured_media.preview_image.url) {
        const imageUrl = `${this.currentVariant.featured_media.preview_image.url}&width=50`
        swatch.style.setProperty("--swatch--background", `url(${imageUrl})`)
      }
    })
  }

  updateKidsSubscriptionWidget() {
    // Trigger click on matching subscription widget variant
    const subscriptionWidget = document.querySelector(".custom-subscription-widget")
    // When there is two variants(including Flavor), update the subscription widget
    if (this.currentVariant && this.currentVariant.optionNames?.length > 1) {
      if (subscriptionWidget) {
        // Toggle visibility of variant options based on selected flavor
        const variantLabels = subscriptionWidget.querySelectorAll(".product-variant-label")
        variantLabels.forEach((label) => {
          const variantInput = subscriptionWidget.querySelector(`#${label.getAttribute("for")}`)
          if (variantInput) {
            const variantFlavor = variantInput.dataset.option1
            label.toggleAttribute("hidden", variantFlavor !== this.currentVariant.option1)
          }
        })
      }
    }

    // Click the matching variant input
    const matchingVariantInput = subscriptionWidget.querySelector(
      `.js-product-variant[value="${this.currentVariant.id}"]`
    )
    if (matchingVariantInput) {
      matchingVariantInput.click()
    }
  }

  updateOptions() {
    const optionElements = document.body.contains(this)
      ? this.querySelectorAll("select, fieldset")
      : document.querySelectorAll(
          ".custom-subscription-widget .product-variants-list input:checked"
        )

    this.options = Array.from(optionElements, (element) => {
      if (element.tagName === "SELECT") {
        return element.value
      }
      if (element.tagName === "FIELDSET") {
        const arr = Array.from(element.querySelectorAll("input"))
        return arr.find((radio) => radio.checked)?.value ?? arr[0].value
      }
      if (element.tagName === "INPUT") {
        return element.dataset.option1
      }
    })
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (variant) =>
        !variant.options.map((option, index) => this.options[index] === option).includes(false)
    )
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target
    if (tagName === "SELECT") {
      const selectedDropdownSwatchValue = this.querySelector(
        `[data-selected-dropdown-swatch="${name}"] > .swatch`
      )
      const relatedProductOptionData = this.querySelector(`[data-product-option="${target.name}"]`)
        ? JSON.parse(this.querySelector(`[data-product-option="${target.name}"]`).textContent)
        : []

      const swatchImage = relatedProductOptionData?.find((option) => option.value === value)?.image

      if (!selectedDropdownSwatchValue) {
        const match = name.match(/\[([^\]]+)\]/)
        const selectedOption = match ? match[1] : null
        const selectedSwatchValue = document.querySelector(
          `[data-selected-swatch-value="${selectedOption}"]`
        )
        if (selectedSwatchValue) {
          selectedSwatchValue.innerHTML = value
        }
        return null
      }
      if (swatchImage) {
        selectedDropdownSwatchValue.style.setProperty("--swatch--background", swatchImage)
        selectedDropdownSwatchValue.classList.remove("swatch--unavailable")
      } else {
        selectedDropdownSwatchValue.style.setProperty("--swatch--background", "unset")
        selectedDropdownSwatchValue.classList.add("swatch--unavailable")
      }
    } else if (tagName === "INPUT" && target.type === "radio") {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`)
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value
    }
  }

  renderDescription() {
    if (
      !this.currentVariant ||
      !this.currentVariant.hasOwnProperty("metafields") ||
      !this.currentVariant.metafields.hasOwnProperty("descriptionOverride")
    ) {
      return
    }

    const container = document.querySelectorAll(".product__description")
    if (!container) {
      return
    }

    for (var i = 0; i < container.length; i++) {
      container[i].innerHTML = this.currentVariant.metafields.descriptionOverride
    }
  }

  renderImages() {
    if (
      !this.currentVariant ||
      !this.currentVariant.hasOwnProperty("metafields") ||
      !this.currentVariant.metafields.hasOwnProperty("additionalImages")
    ) {
      return
    }

    const additionalImages = this.currentVariant.metafields.additionalImages

    if (!additionalImages) {
      return
    }

    const container = document.querySelector(".product-media")
    const thumbnailEl = document.querySelector(".product-thumbnails")

    if (!container) {
      return
    }

    container.innerHTML = ""
    if (thumbnailEl) thumbnailEl.innerHTML = ""

    const mainMediaHTML = additionalImages
      .map((media) => {
        if (item.type === "video" && media.hasOwnProperty("video")) {
          return `
          <div class="full-video swiper-slide">
            <video controls="true">
              <source src="${media.video}" type="${media.mime}">
            </video>
          </div>
        `
        } else {
          const size = window.innerWidth < 1000 ? 500 : 700
          return `
          <div class="full-image swiper-slide">
            <div class="block w1 ha img relative">
              <img data-index="${i}" loading="lazy" src="${media.src.trim()}&width=${size}&height=${size}" alt="${
                media.alt
              }" role="presentation" tabindex="-1" />
            </div>
          </div>
        `
        }
      })
      .join("")

    const thumbsHTML = additionalImages
      .map((media) => {
        if (media.hasOwnProperty("src")) {
          return `<button aria-label="Go to slide ${i + 1}" class="media-thumbnail swiper-slide"><img data-index="${i}" loading="lazy" src="${media.src.trim()}&width=${50}&height=${50}" /></button>`
        }
      })
      .join("")

    container.innerHTML = `<div class="swiper-wrapper">${mainMediaHTML}</div><div class="swiper-pagination"></div>`

    if (thumbnailEl) thumbnailEl.innerHTML = `<div class="swiper-wrapper">${thumbsHTML}</div>`

    const swiper = new Swiper(".product-thumbnails", {
      loop: true,
      spaceBetween: 15,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
    })

    new Swiper(".product-media", {
      loop: true,
      spaceBetween: 0,
      thumbs: {
        swiper: swiper,
      },
      pagination: {
        el: ".product-media .swiper-pagination",
        clickable: true,
      },
    })
  }

  renderImageTag() {
    if (
      !this.currentVariant ||
      !this.currentVariant.hasOwnProperty("metafields") ||
      !this.currentVariant.metafields.hasOwnProperty("variantImageTag")
    ) {
      return
    }

    const container = document.querySelectorAll(".product-tag-overlay-container")
    if (!container) {
      return
    }

    for (var i = 0; i < container.length; i++) {
      if (this.currentVariant.metafields.variantImageTag !== "") {
        container[i].innerHTML =
          `<div class="product-tag-overlay"><p class="special">${this.currentVariant.metafields.variantImageTag}</p></div>`
      } else {
        container[i].innerHTML = ""
      }
    }
  }

  renderTopLeft() {
    if (
      !this.currentVariant ||
      !this.currentVariant.hasOwnProperty("metafields") ||
      !this.currentVariant.metafields.hasOwnProperty("productInfoV2OverrideTopLeft")
    ) {
      return
    }

    const container = document.querySelector('.js-product-info-block[data-position="top-left"]')
    if (!container) {
      return
    }

    container.innerHTML = this.currentVariant.metafields.productInfoV2OverrideTopLeft
  }

  renderTopRight() {
    if (
      !this.currentVariant ||
      !this.currentVariant.hasOwnProperty("metafields") ||
      !this.currentVariant.metafields.hasOwnProperty("productInfoV2OverrideTopRight")
    ) {
      return
    }

    const container = document.querySelector('.js-product-info-block[data-position="top-right"]')
    if (!container) {
      return
    }
    container.innerHTML = this.currentVariant.metafields.productInfoV2OverrideTopRight
  }

  renderTestimonial() {
    if (
      !this.currentVariant ||
      !this.currentVariant.hasOwnProperty("metafields") ||
      !this.currentVariant.metafields.hasOwnProperty("variantTestimonialImage")
    ) {
      return
    }

    const container = document.querySelector(".variant-testimonial")
    if (!container) {
      return
    }

    if (document.querySelector(".variant-testimonial--image")) {
      document.querySelector(".variant-testimonial--image").src =
        this.currentVariant.metafields.variantTestimonialImage
    }
    if (document.querySelector(".variant-testimonial--quote-image")) {
      document.querySelector(".variant-testimonial--quote-image").src =
        this.currentVariant.metafields.variantTestimonialQuoteImage
    }
    if (document.querySelector(".variant-testimonial--copy")) {
      document.querySelector(".variant-testimonial--copy").innerHTML =
        this.currentVariant.metafields.variantTestimonialCopy
    }
    if (document.querySelector(".variant-testimonial--signature-image")) {
      document.querySelector(".variant-testimonial--signature-image").src =
        this.currentVariant.metafields.variantTestimonialSignatureImage
    }

    if (this.currentVariant.metafields.variantTestimonialImage != "") {
      container.classList.remove("hidden")
    } else {
      container.classList.add("hidden")
    }
  }

  hideAccordions() {
    if (!this.currentVariant || !this.currentVariant.hasOwnProperty("title")) {
      return
    }
    const curTitle = this.currentVariant.title
    if (debug) {
      console.log("curTitle", this.currentVariant.title)
    }
    if (document.querySelectorAll("[data-hide-when]")) {
      document.querySelectorAll("[data-hide-when]").forEach(function (el) {
        if (debug) {
          console.log("hiders", el)
        }
        el.style.display = "block"
        const hideWhen = el.dataset.hideWhen
        if (curTitle.includes(hideWhen)) {
          if (debug) {
            console.log("hideWhen", hideWhen)
          }
          el.style.display = "none"
        }
      })
    }
  }

  renderNutrition() {
    if (
      !this.currentVariant ||
      !this.currentVariant.hasOwnProperty("metafields") ||
      !this.currentVariant.metafields.hasOwnProperty("nutritionImage")
    ) {
      return
    }

    const container = document.querySelectorAll(
      '.product-info__modal[data-id="nutritional"] .info-modal__content img'
    )
    if (!container) {
      return
    }

    for (var i = 0; i < container.length; i++) {
      container[i].src = this.currentVariant.metafields.nutritionImage
      container[i].srcset = ""
    }
  }

  updateSingleSelector(number, config, event) {
    if (debug) {
      console.log("==== Update Single Selector ====")
    }
    var currentValue = currentVariant[number + 1]
    const selectElement = document.getElementById(selectorName + (number + 1))

    if (selectElement) {
      // deal with selects
      const selector = selectElement.closest(".selector")
      selectElement.disabled = false
      selectElement.value = currentValue
      Array.from(selectElement.options).forEach((option) => {
        if (config.hasOwnProperty(option.value)) {
          option.disabled = false
          option.classList.add("available")
        } else {
          option.disabled = true
          option.classList.remove("available")
        }
      })

      // Deselect options that are disabled
      // Select first available option
      const vanillaSelect = document.getElementById(selectorName + (number + 1))
      let deselected = false

      vanillaSelect.querySelectorAll("option").forEach((option) => {
        if (option.disabled) {
          option.selected = false
          deselected = true
        }
      })
      const firstAvailableOption = vanillaSelect.querySelector("option:not([disabled])")

      if (firstAvailableOption && deselected) {
        firstAvailableOption.selected = true
      }
    } else if ($('.radio-element input[name="option-' + (number + 1) + '"]').length) {
      // deal with radios
      var $radios = $('.radio-element input[name="option-' + (number + 1) + '"]'),
        $selector = $radios.parents(".selector")
      $radios.each(function () {
        if (config.hasOwnProperty($(this).val())) {
          if (currentValue === $(this).val() || Object.keys(config).length === 1) {
            $(this).prop("checked", true)
          }
          $(this).prop("disabled", false)
          $(this).parent("label").addClass("available")

          if (
            config[$(this).val()].hasOwnProperty("support") &&
            config[$(this).val()].support.length
          ) {
            $(this)
              .parents(".radio-element")
              .find(".supporting-text")
              .text(config[$(this).val()].support)
          }
          if (config[$(this).val()].hasOwnProperty("popup")) {
            var popData = config[$(this).val()].popup,
              $popup = $(this).parents(".radio-element").find(".radio-popup")
            if (popData.hasOwnProperty("trigger")) {
              $(this).parents(".radio-element").find(".popup-trigger").text(popData.trigger)
            }
            if (popData.hasOwnProperty("image")) {
              if (popData.image.hasOwnProperty("background")) {
                $popup
                  .find(".details-primary .details-image-surround")
                  .css("background-color", popData.image.background)
                $popup.find(".details-bottom").css("background-color", popData.image.background)
              }
              if (popData.image.hasOwnProperty("src")) {
                $popup.find(".details-image").each(function () {
                  $(this).prop("src", popData.image.src)
                })
              }
            }
            if (popData.hasOwnProperty("accordions")) {
              var markup = ""
              for (var a = 0; a < popData.accordions.length; a++) {
                markup += '<div class="accordion'
                if (a === 0) {
                  markup += " expanded"
                }
                markup += '">'
                markup +=
                  '<a href="#" class="accordion-head">' + popData.accordions[a].headline + "</a>"
                markup += '<div class="accordion-body"'
                if (a === 0) {
                  markup += ' style="display: block;"'
                }
                markup += ">" + popData.accordions[a].content + "</div>"
                markup += "</div>"
              }
              $popup.find(".details-accordions").html(markup)
            }
            if (Object.keys(config).length <= 1) {
              $popup.find(".choose-this-radio").hide()
            } else {
              $popup.find(".choose-this-radio").show()
            }
          }
        } else {
          $(this).prop("disabled", true)
          $(this).parent("label").removeClass("available")
        }
      })

      if (Object.keys(config).length === 0) {
        $selector.slideUp(300)
      } else if (Object.keys(config).length === 1) {
        currentValue = Object.keys(config)[0]
        $radios.each(function () {
          $(this).prop("disabled", true)
        })
        $selector.addClass("disabled")
        $selector.slideDown(300)
      } else {
        $radios.each(function () {
          $(this).prop("disabled", false)
        })
        $selector.removeClass("disabled")
        $selector.slideDown(300)
      }
    }

    // and then the next level
    if (
      typeof config !== "undefined" &&
      config.hasOwnProperty(currentValue) &&
      config[currentValue].hasOwnProperty("values")
    ) {
      this.updateSingleSelector(number + 1, config[currentValue].values)
    } else {
      this.updateOptions()
      this.updateMasterId()
      if (event) this.updateSelectedSwatchValue(event)
      document.getElementById("product-select").value = this.currentVariant.id
      this.onVariantChange(new Event("change"))
    }
  }

  updateOtherSelectors($this) {
    if (debug) {
      console.log("====UPDATE OTHER SELECTORS=====")
    }
    let selectorNumber = parseInt($this.parents(".selector").data("option-index"))
    let currentVal = $this.val()
    currentVariant[selectorNumber] = currentVal
    var path = "values."
    for (var i = 0; i < radioOptions.length; i++) {
      if (selectorNumber === i) {
        path += currentVal + ".values"
      } else if (selectorNumber >= i) {
        path += currentVariant[i] + ".values."
      }
    }
    if (debug) {
      console.log("currentVal", currentVal)
    }
    if (path !== "values.") {
      var currentConfig = getValue(availableOptions, path)
      this.updateSingleSelector(selectorNumber, currentConfig)
    }
  }

  /* RECHARGE MODS START */

  modifyPriceDisplays() {
    // RECHARGE MODS 3: update variant-altering data within boxes
    variant = selectedVariant
    const originalPrice = Shopify.formatMoney(priceHub[variant.id]).replace(".00", "")
    let servingSize = null
    if (document.querySelector(".serving-size")) {
      servingSize = parseInt(document.querySelector(".serving-size").textContent)
    }
    if (debug) {
      console.log("priceHub", priceHub[variant.id])
    }

    if (originalPrice) {
      // a) show subscription savings by striking out original amount
      const subPrice = document.querySelector(
        ".rc-radio.subscription-radio .rc-radio__label .rc-radio__price"
      )
      const strikeContainer = document.querySelector(
        ".rc-radio.subscription-radio .rc-radio__label .rc_original__price"
      )
      const subServing = document.querySelector(
        ".rc-radio.subscription-radio .rc-radio__label .rc-serving-amount"
      )
      if (strikeContainer) {
        strikeContainer.innerHTML = originalPrice
      } else {
        const wrap = document.createElement("span")
        wrap.classList.add("rc_sale__price")
        wrap.textContent = subPrice.textContent

        const span = document.createElement("span")
        span.classList.add("rc_original__price")
        span.innerHTML = originalPrice
        span.setAttribute("aria-label", "Original Price")
        span.setAttribute("aria-hidden", "true")
        subPrice.textContent = ""
        subPrice.prepend(span)
        subPrice.append(wrap)
      }

      // b) store subscription's original price for next step, but then remove the cents if even dollar amount
      const forSale = document.querySelector(
        ".rc-radio.subscription-radio .rc-radio__label .rc-radio__price .rc_sale__price"
      )
      let salePrice = parseInt(forSale.textContent.replace("$", "").replace(".", ""))
      let saleText = forSale.textContent.replace(".00", "")
      if (this.j4Discount.skus.includes(this.currentVariant.sku)) {
        salePrice = priceHub[this.currentVariant.id] * (1 - this.j4Discount.sub_percent_off / 100)
        saleText = Shopify.formatMoney(salePrice).replace(".00", "")
      } else {
        if (
          rechargeMods.hasOwnProperty("sub_percent_off") &&
          parseInt(rechargeMods.sub_percent_off)
        ) {
          salePrice = priceHub[variant.id] * (1 - rechargeMods.sub_percent_off / 100)
          saleText = Shopify.formatMoney(salePrice).replace(".00", "")
        }
      }
      forSale.textContent = saleText

      // c) update subscription's per-serving price
      if (
        servingSize &&
        rechargeMods.hasOwnProperty("per_serving") &&
        rechargeMods.per_serving.length
      ) {
        let subPer = Shopify.formatMoney(salePrice / servingSize).replace(".00", "")
        if (subServing) {
          subServing.textContent = subPer
        }
        document.querySelector(
          ".rc-radio.subscription-radio .rc-radio__label .rc-per_serving"
        ).style.display = "block"
      } else {
        document.querySelector(
          ".rc-radio.subscription-radio .rc-radio__label .rc-per_serving"
        ).style.display = "none"
      }

      // d) update OTP's price and corresponding per-serving
      const priceContainer = document.querySelector(
        ".rc-radio.onetime-radio .rc-radio__label .rc-radio__price"
      )
      const otpServing = document.querySelector(
        ".rc-radio.onetime-radio .rc-radio__label .rc-serving-amount"
      )
      if (priceContainer) {
        if (
          this.j4Discount.skus.includes(this.currentVariant.sku) &&
          this.j4Discount.hasOwnProperty("otp_percent_off") &&
          parseInt(this.j4Discount.otp_percent_off)
        ) {
          priceContainer.innerHTML =
            '<span class="rc_original__price">' +
            originalPrice +
            '</span><span class="rc-sale__price">' +
            Shopify.formatMoney(
              priceHub[variant.id] * ((100 - parseInt(this.j4Discount.otp_percent_off)) / 100)
            ).replace(".00", "") +
            "</span>"
        } else {
          if (
            rechargeMods.hasOwnProperty("otp_percent_off") &&
            parseInt(rechargeMods.otp_percent_off)
          ) {
            priceContainer.innerHTML =
              '<span class="rc_original__price">' +
              originalPrice +
              '</span><span class="rc-sale__price">' +
              Shopify.formatMoney(
                priceHub[variant.id] * ((100 - parseInt(rechargeMods.otp_percent_off)) / 100)
              ).replace(".00", "") +
              "</span>"
          } else {
            priceContainer.innerHTML = originalPrice
          }
        }
      }
      if (
        otpServing &&
        servingSize &&
        Object.prototype.hasOwnProperty.call(rechargeMods, "per_serving") &&
        rechargeMods.per_serving.length
      ) {
        let calcPrice = priceHub[variant.id]
        if (
          this.j4Discount.skus.includes(this.currentVariant.sku) &&
          this.j4Discount.hasOwnProperty("otp_percent_off") &&
          parseInt(this.j4Discount.otp_percent_off)
        ) {
          calcPrice =
            priceHub[variant.id] * ((100 - parseInt(this.j4Discount.otp_percent_off)) / 100)
        } else if (
          Object.prototype.hasOwnProperty.call(rechargeMods, "otp_percent_off") &&
          parseInt(rechargeMods.otp_percent_off)
        ) {
          calcPrice = priceHub[variant.id] * ((100 - parseInt(rechargeMods.otp_percent_off)) / 100)
        }
        let otpPer = Shopify.formatMoney(calcPrice / servingSize).replace(".00", "")
        otpServing.textContent = otpPer
        document.querySelector(
          ".rc-radio.onetime-radio .rc-radio__label .rc-per_serving"
        ).style.display = "block"
      } else {
        document.querySelector(
          ".rc-radio.onetime-radio .rc-radio__label .rc-per_serving"
        ).style.display = "none"
      }

      // e) update subscriptions's savings badge

      const subPercentOff = document.querySelector(
        ".rc-radio.subscription-radio .rc-radio__label .rc-percent_off"
      )

      if (subPercentOff) {
        if (
          this.j4Discount.skus.includes(this.currentVariant.sku) &&
          this.j4Discount.hasOwnProperty("sub_percent_off") &&
          parseInt(this.j4Discount.sub_percent_off)
        ) {
          subPercentOff.textContent = `Save ${this.j4Discount.sub_percent_off}%`
          subPercentOff.classList.remove("hidden")
        } else if (
          rechargeMods.hasOwnProperty("sub_percent_off") &&
          parseInt(rechargeMods.sub_percent_off)
        ) {
          if (rechargeMods.hasOwnProperty("sub_label_prefix")) {
            subPercentOff.textContent = rechargeMods.sub_label_prefix + " "
          } else if (rechargeMods.hasOwnProperty("save_label")) {
            subPercentOff.textContent = rechargeMods.save_label + " "
          }
          subPercentOff.textContent += rechargeMods.sub_percent_off + "%"
          if (rechargeMods.hasOwnProperty("sub_label_suffix")) {
            subPercentOff.textContent += " " + rechargeMods.sub_label_suffix
          }
          subPercentOff.classList.remove("hidden")
        } else {
          subPercentOff.textContent = ``
          subPercentOff.classList.add("hidden")
        }
      }

      // f) update OTP's savings badge
      const otherPercentOff = document.querySelector(
        ".rc-radio.onetime-radio .rc-radio__label .rc-percent_off"
      )

      if (otherPercentOff) {
        if (
          this.j4Discount.skus.includes(this.currentVariant.sku) &&
          this.j4Discount.hasOwnProperty("otp_percent_off") &&
          parseInt(this.j4Discount.otp_percent_off)
        ) {
          otherPercentOff.textContent = `Save ${this.j4Discount.otp_percent_off}%`
          otherPercentOff.classList.remove("hidden")
        } else if (
          rechargeMods.hasOwnProperty("otp_percent_off") &&
          parseInt(rechargeMods.otp_percent_off)
        ) {
          if (rechargeMods.hasOwnProperty("otp_label_prefix")) {
            otherPercentOff.textContent = rechargeMods.otp_label_prefix + " "
          }
          otherPercentOff.textContent += rechargeMods.otp_percent_off + "%"
          if (rechargeMods.hasOwnProperty("otp_label_suffix")) {
            otherPercentOff.textContent += " " + rechargeMods.otp_label_suffix
          }
          otherPercentOff.classList.remove("hidden")
        } else {
          otherPercentOff.textContent = ``
          otherPercentOff.classList.add("hidden")
        }
      }

      // g) update sticky ATC savings badge
      if (document.querySelector("product-form-sticky")) {
        const stickyATCPriceEl = document.querySelector(".js-sticky-atc-price")
        const stickyATCSalePriceEl = document.querySelector(".js-sticky-atc-sale-price")
        const activeOriginalPrice = document.querySelector(
          ".recharge-subscription-widget .rc-widget .rc-radio.rc-radio--active .rc_original__price"
        )?.innerText
        const activeSalePrice = document.querySelector(
          ".recharge-subscription-widget .rc-widget .rc-radio.rc-radio--active .rc_sale__price"
        )?.innerText
        const activePrice = document.querySelector(
          ".recharge-subscription-widget .rc-widget .rc-radio.rc-radio--active .rc-radio__price"
        )?.innerText

        if (activeOriginalPrice && activeSalePrice) {
          stickyATCPriceEl.innerText = activeOriginalPrice
          stickyATCSalePriceEl.innerText = activeSalePrice
          stickyATCSalePriceEl.classList.remove("hidden")
        } else {
          stickyATCPriceEl.innerText = activePrice
          stickyATCSalePriceEl.classList.add("hidden")
        }
      }
    }
  }
  /* RECHARGE MODS END */

  updateMedia() {
    if (!this.currentVariant) return
    if (!this.currentVariant.featured_media) return

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`)
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    )

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    )
    if (!modalContent) return
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    )
    modalContent.prepend(newMediaModal)
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return

    // Get the current URL
    const url = new URL(window.location)

    // Update the 'variant' parameter or add it if it doesn't exist
    url.searchParams.set("variant", this.currentVariant.id)

    // Replace the current history state with the new URL
    window.history.replaceState({}, "", url)
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`)
    if (!shareButton || !shareButton.updateUrl) return
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`)
  }

  updateKidsDropdown() {
    const kidsDropdown = document.querySelector('[name="options[Kids]"]')
    if (!kidsDropdown) return

    const index = this.currentVariant.optionNames.indexOf("Kids")
    const option = this.currentVariant[`option${index + 1}`]
    kidsDropdown.value = option
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    )
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('[name="id"]')
      if (!input) return
      input.value = this.currentVariant.id
      // eslint-disable-next-line no-undef
      selectedVariant = this.currentVariant // selectedVariant defined in sections/main-product.liquid
      input.dispatchEvent(
        new CustomEvent("change", {
          bubbles: true,
          detail: {
            variant: this.currentVariant,
          },
        })
      )
      document.dispatchEvent(
        new CustomEvent("PRODUCT_FORM_CHANGED", {
          bubbles: true,
          detail: {
            variant: this.currentVariant.id || "",
          },
        })
      )
    })
  }

  updateVariantStatuses() {
    const variantOptionContainer = document.body.contains(this)
      ? this
      : document.querySelector(".custom-subscription-widget .product-variants-list")

    const selectedOptionOneVariants = [
      this.variantData.find(
        (variant) => variantOptionContainer.querySelector(":checked")?.value === variant.option1
      ) ?? this.variantData[0],
    ]

    if (this.querySelector(".js-no-discount")) {
      this.querySelector(".js-no-discount").value = this.j4Discount.skus.includes(
        this.currentVariant?.sku
      )
    }

    const inputWrappers = [...this.querySelectorAll(".product-form__input")]
    inputWrappers.forEach((option, index) => {
      if (index === 0) return
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(":checked").value
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) => variant.available && variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`])
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    })
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute("value")
      const availableElement = availableValuesList.includes(value)

      if (element.tagName === "INPUT") {
        element.classList.toggle("disabled", !availableElement)
      } else if (element.tagName === "OPTION") {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace("[value]", value)
      }
    })
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability")
    if (!pickUpAvailability) return

    if (
      this.currentVariant &&
      this.currentVariant.available &&
      typeof pickUpAvailability.fetchAvailability !== "undefined"
    ) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute("available")
      pickUpAvailability.innerHTML = ""
    }
  }

  removeErrorMessage() {
    const section = this.closest("section")
    if (!section) return

    const productForm = section.querySelector("product-form")
    if (productForm && typeof productForm.handleErrorMessage !== "undefined")
      productForm.handleErrorMessage()
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section

    if (typeof amplitude !== "undefined") {
      const options = Object.fromEntries(
        this.currentVariant.optionNames.map((option, index) => [
          option,
          this.currentVariant.options[index],
        ])
      )
      const data = {
        product_id: this.dataset.productId,
        variant_id: this.currentVariant.id,
        variant_name: this.currentVariant.name,
        ...options,
      }
      window.amplitude.track("Page Viewed", data)
      window.amplitude.track("Product Viewed", data)
      window.amplitude.track("Flavor Change", data)
    }

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return

        const html = new DOMParser().parseFromString(responseText, "text/html")
        const destination = document.getElementById(`price-${this.dataset.section}`)
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        )
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        )
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`)
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        )
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`)

        const volumePricingSource = html.getElementById(
          `Volume-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        )

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`
        )
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        )

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`)
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`)
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`)

        if (volumeNote) volumeNote.classList.remove("hidden")
        if (volumePricingDestination) volumePricingDestination.classList.remove("hidden")
        if (qtyRules) qtyRules.classList.remove("hidden")

        if (source && destination) destination.innerHTML = source.innerHTML
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML
          skuDestination.classList.toggle("hidden", skuSource.classList.contains("hidden"))
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML
          pricePerItemDestination.classList.toggle(
            "hidden",
            pricePerItemSource.classList.contains("hidden")
          )
        }

        const price = document.getElementById(`price-${this.dataset.section}`)

        if (price) price.classList.remove("hidden")

        if (inventoryDestination)
          inventoryDestination.classList.toggle("hidden", inventorySource.innerText === "")

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`)
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        )

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        })
      })
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`)
    if (!productForm) return
    const addButton = productForm.querySelector('[name="add"]')
    const addButtonText = productForm.querySelector('[name="add"] > span')
    if (!addButton) return

    if (disable) {
      addButton.setAttribute("disabled", "disabled")
      if (text) addButtonText.textContent = text
    } else {
      addButton.removeAttribute("disabled")
      addButtonText.textContent = window.variantStrings.addToCart
    }

    if (!modifyClass) return
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`)
    const addButton = button.querySelector('[name="add"]')
    const addButtonText = button.querySelector('[name="add"] > span')
    const price = document.getElementById(`price-${this.dataset.section}`)
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`)
    const sku = document.getElementById(`Sku-${this.dataset.section}`)
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`)
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`)
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`)
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`)

    if (!addButton) return
    addButtonText.textContent = window.variantStrings.unavailable
    if (price) price.classList.add("hidden")
    if (inventory) inventory.classList.add("hidden")
    if (sku) sku.classList.add("hidden")
    if (pricePerItem) pricePerItem.classList.add("hidden")
    if (volumeNote) volumeNote.classList.add("hidden")
    if (volumeTable) volumeTable.classList.add("hidden")
    if (qtyRules) qtyRules.classList.add("hidden")
  }

  getVariantData() {
    this.variantData = this.variantData || variantData
    return this.variantData
  }

  updateSwatchImage(event) {
    if (event && event.target) {
      console.log("testtttt", event.target)
    }
  }
}

customElements.define("variant-selects", VariantSelects)

class ProductRecommendations extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return
      observer.unobserve(this)

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div")
          html.innerHTML = text
          const recommendations = html.querySelector("product-recommendations")

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove()
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded")
          }
        })
        .catch((e) => {
          console.error(e)
        })
    }

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this)
  }
}

customElements.define("product-recommendations", ProductRecommendations)

class CustomModal extends HTMLElement {
  constructor() {
    super()

    document.querySelectorAll(".js-custom-modal-trigger").forEach((trigger) => {
      trigger?.addEventListener("click", this.openModal.bind(this))
    })

    this.closeTrigger?.addEventListener("click", this.closeModal.bind(this))
    this.addEventListener("click", this.onClick.bind(this))
  }

  onClick(event) {
    if (
      !event.target.closest(".js-modal-inner") &&
      !event.target.classList.contains("js-modal-inner")
    ) {
      this.closeModal()
    }
  }

  openModal(event) {
    const triggerModalId = event.currentTarget?.getAttribute("data-custom-modal-id") || ""
    if (this.modalId == triggerModalId) this.classList.add("show-modal")
  }

  closeModal() {
    this.classList.remove("show-modal")
  }

  get closeTrigger() {
    return this.querySelector(".js-modal-close")
  }

  get inner() {
    return this.querySelector(".js-modal-inner")
  }

  get modalId() {
    return this.getAttribute("data-custom-modal-id")
  }
}

customElements.define("custom-modal", CustomModal)

class SelectPopup extends HTMLElement {
  constructor() {
    super()

    this.trigger?.addEventListener("click", this.openModal.bind(this))
    this.closeTrigger?.addEventListener("click", this.closeModal.bind(this))
    document.addEventListener("click", this.onDocumentClick.bind(this))

    this.items.forEach((item) => {
      item.addEventListener("click", this.onItemClick.bind(this))
    })
  }

  onItemClick(event) {
    const item = event.currentTarget
    if (this.selectedItem) this.selectedItem.innerHTML = item.innerHTML
    this.closeModal()
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) this.closeModal()
  }

  openModal() {
    this.classList.add("active")
  }

  closeModal() {
    this.classList.remove("active")
  }

  get trigger() {
    return this.querySelector(".js-trigger")
  }

  get closeTrigger() {
    return this.querySelector(".js-close")
  }

  get selectedItem() {
    return this.querySelector(".js-selected")
  }

  get items() {
    return this.querySelectorAll(".js-item")
  }
}

customElements.define("select-popup", SelectPopup)
